import { css } from 'lit';
export class PublicAppStyles {
    static stylesApp = [css`
        :host {
            display: block;
            box-sizing: border-box;
        }
    `];

    static stylesTables = [css`
        .krypton-table-style{
            width: 100%;
            height: 100%;
            border: 0px;
            border-collapse: collapse;
        }
    `];

    static stylesHeader = [css`
        :host {
            display: block;
        }
    `];
}
